import { useCallback, useEffect, useState } from 'react';
import { listPaymentLinks, syncPaymentLink, deletePaymentLink } from '../services/paymentLinkService';

/**
 * Histórico de links de pagamento já gerados — busca ao montar e expõe
 * refetch pra atualizar a lista depois de gerar um link novo, além de
 * ressincronizar status e excluir do histórico.
 */
export function usePaymentLinksHistory() {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchHistory = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const doc = await listPaymentLinks();
      setLinks(doc || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  const sync = useCallback(
    async (id) => {
      await syncPaymentLink(id);
      await fetchHistory();
    },
    [fetchHistory]
  );

  const remove = useCallback(
    async (id) => {
      await deletePaymentLink(id);
      await fetchHistory();
    },
    [fetchHistory]
  );

  return { links, loading, error, refetch: fetchHistory, sync, remove };
}
